<template>
    <div v-if="data" class="menu-blocks-item">
        <div @click="togglePopup" @mouseover="isHovered = true" @mouseout="isHovered = false" class="main-block">
            <WpImage v-if="data.featured_image" size="medium_large" :image="data.featured_image" lazy background cover/>
            <div class="padding-lg">
                <h3 class="titler large-title">{{data.title}}</h3>
                <p v-if="data.acf.short_description" class="desc small-text">{{data.acf.short_description}}</p>
                <div class="button-row">

                    <div class="price" v-if="data.acf.price">
                        kr. {{data.acf.price}},- <span v-if="checkVat(data.acf.price_inc_vat)">inkl. mva</span><span v-else>ekskl. mva</span><template v-if="data.acf.price_secondary"> / {{data.acf.price_secondary}},- <span v-if="checkVat(data.acf.price_secondary_inc_vat_copy)">inkl. mva</span><span v-else>ekskl. mva</span></template>
                    </div>

                    <Button :class="{'hover' : isHovered}" type="yellowLight" bold>
                        <span>Ingredienser og allergener</span>
                        <svg class="icon" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><defs/><path d="M14.118 6.095H9.905V1.882C9.905.847 9.035 0 8 0 6.965 0 6.095.847 6.095 1.882v4.213H1.882C.847 6.095 0 6.965 0 8c0 1.035.847 1.905 1.882 1.905h4.213v4.213C6.095 15.153 6.965 16 8 16c1.035 0 1.905-.847 1.905-1.882V9.905h4.213C15.153 9.905 16 9.035 16 8c0-1.035-.847-1.905-1.882-1.905z" fill="#2A343C"/></svg>
                    </Button>


                </div>
            </div>
        </div>
        <transition name="opacity">
        <div v-show="showPopup" :class=" {'show-me' : showPopup}" class="block-popup">
            <div @click="togglePopup" class="overlay"></div>
            <div class="popup-inner">
                <div class="content padding-lg">
                    <div class="top-popup">
                        <h4 class="titler medium-text">{{data.title}}</h4>
                        <span class="close-button" @click="togglePopup">
                            <svg class="icon" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><defs/><path d="M14.118 6.095H9.905V1.882C9.905.847 9.035 0 8 0 6.965 0 6.095.847 6.095 1.882v4.213H1.882C.847 6.095 0 6.965 0 8c0 1.035.847 1.905 1.882 1.905h4.213v4.213C6.095 15.153 6.965 16 8 16c1.035 0 1.905-.847 1.905-1.882V9.905h4.213C15.153 9.905 16 9.035 16 8c0-1.035-.847-1.905-1.882-1.905z" fill="#FFFDD6"/></svg>
                        </span>
                    </div>
                    <div class="popup-desc small-text" v-html="data.acf.full_description"></div>
                    <div class="button-row">
                        <div class="price" v-if="data.acf.price">
                        kr. {{data.acf.price}},- <span v-if="checkVat(data.acf.price_inc_vat)">inkl. mva</span><span v-else>ekskl. mva</span><template v-if="data.acf.price_secondary"> / {{data.acf.price_secondary}},- <span v-if="checkVat(data.acf.price_secondary_inc_vat_copy)">inkl. mva</span><span v-else>ekskl. mva</span></template>
                        </div>
                    </div>
                    <div class="ingrediens" v-if="data.acf.ingredients_list && data.acf.ingredients_list.length">
                        <div class="naming mid-text">Ingredienser og allergener</div>
                        <ul v-if="data.acf.ingredients_list" class="ingr-list">
                            <li class="single-ing" v-for="(ing, i) in data.acf.ingredients_list" :key="i">
                                <div class="name small-text">{{ing.ingredient_name}}</div>
                                <div class="allergens text-italic tiny-text">
                                    <template v-if="ing.alergens && ing.alergens.length">
                                        {{displayAlergens(ing.alergens)}}
                                    </template>
                                    <template v-else>
                                        Ingen allergener
                                    </template>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import { addClass, removeClass, capitalize } from '@/helpers'
import Button from '@/components/elements/Button'
import WpImage from '@/components/elements/WpImage'

export default {
    name: 'menu-box',
    props: {
        // in %
        data: {
            type: Object,
        },
        
    },
    data(){
        return {
            showPopup: false,
            isHovered: false
        }
    },
    components:{
       Button,
       WpImage
    },
    methods:{
        checkVat(vat){
            return (vat === 'undefined' || vat!== false)
        },

        togglePopup(){
            this.showPopup = !this.showPopup;
            const doc = document.getElementsByTagName('html')[0]
            if(this.showPopup){
                addClass(doc, 'show-popup')
            }else{
                removeClass(doc, 'show-popup')
            }
        },
        displayAlergens(alergens){
            const elements = alergens.map((e, i) =>{
                return (i !==  0) ? e.name.toLowerCase() : capitalize(e.name);
            })
            return elements.join(', ').replace(/, ([^,]*)$/, ' og $1')
        }
    }
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.menu-blocks-item{
    .block-popup{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999; 
        
        &.show-me{
            
        }
        .popup-desc{
            padding-right: 125px;
            @include mquery($phone){
                padding-right: 0px;
                margin-top: -20px;
            }

        }
        .top-popup{
            display: flex;
            justify-content: space-between;
            @include mquery($phone){
                .titler{
                    font-size: 22px;
                    margin-top: 30px;
                }
            }

            
            .close-button{
                margin-left: 15px;
                @include mquery($phone){
                    position: fixed;
                    top: 15px;
                    right: 15px;
                }
            }
            
        }
        .close-button{
            background: $dark;
            width: 50px;
            display: inline-block;
            height: 50px;
            border-radius: 50px;
            position: relative;
            transform: rotate(45deg);
            transition: 0.2s background ease-in-out;
            cursor: pointer;
            @include mquery($phone){
                width: 30px;
                height: 30px
            }
            .icon{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                path{
                    transition: 0.2s fill ease-in-out;
                }
            }
            &:hover{
                background-color: $yellow;
                .icon{
                    path{
                        fill: $dark;
                    }
                }
            }
        }
        .ingr-list{
            margin: 0;
            padding: 0;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .single-ing{
                max-width: 50%;
                width: 100%;
                border: 1px solid $yellowLight;
                border-bottom: 2px solid $yellowLight;
                border-top: none;
                padding: 15px;
                &:nth-child(even){
                    border-right: none;
                    padding-right: 0px;
                }
                &:nth-child(odd){
                    border-left: none;
                    padding-left: 0px;
                }
                &:nth-last-child(-n+2){
                    border-bottom: none;
                    padding-bottom: 0px;
                }
                &:nth-child(-n + 2){
                    padding-top: 0px;
                }
                @include mquery($phone){
                    max-width: 100%;
                    width: 100%;
                    border: none !important;
                    padding: 15px 0 !important;
                    border-bottom: 2px solid $yellowLight !important;
                }
            }
            .allergens{
                margin-top: 8px;
            }
        }
        .button-row{
            margin-top: 25px;
            @include mquery($phone){
                .price{
                    display: inline-block;
                }
            }

        }
        .ingrediens{
            margin-top: 50px;
            @include mquery($phone){
                margin-top: 25px;
            }
            .naming{
                font-family: $secndaryFont;
                margin-bottom: 15px;
            }
        }
        .overlay{
            backdrop-filter: blur(14px);
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            cursor: pointer;
            position: absolute;
            background: rgba(255,255,255, 0.6);
            transition: 0.2s all ease-in-out;
            @include mquery($phone){
                backdrop-filter: none;
            }

        }
        .popup-inner{
            position: absolute;
            max-width: 1040px;
            width: 100%;
            left: 50%;
            left: calc(50% - 50px);
            transform: translateX(-50%);
            margin: 125px;
            max-height: 80%;
            max-height: calc(100% - 250px);
            overflow: auto;
            background-color: $yellowLighten;
            margin-left: 50px;
            margin-right: 50px;
            border-top: 10px solid $yellowLighten;
            border-bottom: 10px solid $yellowLighten;
            @include mquery($tablet){
                left: 15px;
                right: 15px;
                transform: none;
                margin: 0;
                margin-top: 50px;
                max-height: calc(100vh - 50px);
            }
            @include mquery($phone){
                left: 0px;
                right: 0px;
                margin-top: 0px;
                max-height: 100vh;
                top: 0;
                bottom: 0;
            }

        }
    }
    .main-block{
        display: flex;
        background-color: $yellowLighten;
        transition: 0.2s background ease-in-out;
        cursor: pointer;
        @include mquery($phone){
            display: block;
            .titler{
                font-size: 24px;
                word-break: break-word;
            }
        }
        &:hover{
            background-color: $yellow;
        }
    }
    .wp-image-vue{
        min-width: 240px;
        .image{
            padding-bottom: 0 !important;
            height: 100% !important;
            background-size: cover;
        }
        @include mquery($tablet){
            min-width: 200px;   
        }
        @include mquery($phone){
            min-width: 100%;   
            .image{
                padding-bottom: 36% !important;
            }

        }

    }
    .fill-button{
        font-family: $mainFont;
        padding-left: 50px;
        left: -30px;
        cursor: pointer;
        z-index: 1;
        position: relative;
        @include mquery($tablet){
            padding-left: 40px;
            left: -25px;           
        }
        @include mquery($phone){
            padding-left: 16px;
            left: 0px;
            display: block;
            width: 100%;
            text-align: left;
            margin-top: 8px;
            background-color: $yellow;
        }

        .icon{
            margin-left: 15px;
            @include mquery($tablet){
                margin-left: 12px;
            }
            @include mquery($tablet){
                top: 2px;
                position: relative;
            }

            /* path{
                transition: 0.2s fill ease-in-out;
            } */
        }
        /* &:hover, &.hover{
            .icon{
                path{
                    //fill: $yellowLighten;
                }
            }
        } */
    }
    .desc{
        margin-top: 15px;
        margin-bottom: 25px;
        @include mquery($tablet){

        }

    }
    .button-row{
        display: flex;
        @include mquery($phone){
            display: block;
        }

        .price{
            z-index: 5;
            position: relative;
            border-radius: $radius;
            padding: 12px 25px;
            @include fluid-type($smallResText, $wideResText, 16px, 20px);
            font-weight: 600;
            color: $yellowLighten;
            background-color: $dark;
            @include mquery($tablet){
                padding: 8px 20px;
            }
            @include mquery($phone){
                padding: 8px 16px;
                display: inline-block;
            }
        }
    }
}
</style>